export default __webpack_public_path__ + "static/media/ripple.4ee19f6d.png";